module.exports = __webpack_public_path__ + "img/Trampolin.0e45dbd9.svg";